import classnames from "classnames";
import React from "react";
import Breadcrumbs, { Breadcrumb } from "../Breadcrumbs/Breadcrumbs";
import { Col, Row } from "../Grid";
import styles from "./BreadcrumbsRow.module.scss";

interface BreadcrumbsRowProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
  xs?: number | "auto" | undefined;
  sm?: number | "auto" | undefined;
  md?: number | "auto" | undefined;
}

const BreadcrumbsRow = ({
  breadcrumbs,
  className,
  xs,
  sm = 10,
  md
}: BreadcrumbsRowProps) => (
  <Row justify="center" className={classnames(styles.root, className)}>
    <Col xs={xs} sm={sm} md={md}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </Col>
  </Row>
);

export default BreadcrumbsRow;
